import { CRUD } from "@/shared/components";
import {
  MailerConfigsListQuery,
  MailerConfigShowQuery,
  DeleteMailerConfigsMutation,
  RestoreMailerConfigsMutation,
} from "@/admin/entities/mailerConfigs";
import { useMailerConfigsManagement, type MailerConfigRow } from "../model";
import * as MailerConfigsSchemas from "../model/schemas";
import { createEditSchema } from "../model/schemas";
import { MailerConfigShowComponent } from "@/admin/features/mailerConfigs";

export function MailerConfigs() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useMailerConfigsManagement();

  return (
    <CRUD<MailerConfigRow>
      listQuery={MailerConfigsListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={MailerConfigsSchemas.filterSchema}
      createSchema={MailerConfigsSchemas.createSchema}
      editSchema={createEditSchema(MailerConfigShowComponent)}
      editQuery={MailerConfigShowQuery}
      deleteMutation={DeleteMailerConfigsMutation}
      restoreMutation={RestoreMailerConfigsMutation}
      texts={texts}
      persistFilters
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
